// extracted by mini-css-extract-plugin
export default {"installAllButton":"InstallOnAllDevices_installAllButton__NDtfk","online":"InstallOnAllDevices_online__+yuKL","offline":"InstallOnAllDevices_offline__n+qeE"};